export default "__VITE_ASSET__7fd38ab0__"